import { Card, Table, Tag, Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/lib/axios'

interface RdaSenzaRdoRow {
  work_order_id: number
  numero_scheda?: string
  cliente_nome?: string
  targa?: string
  marca?: string
  modello?: string
  descrizione_intervento?: string
}

const columns = [
  {
    title: 'OdL',
    dataIndex: 'numero_scheda',
    key: 'numero_scheda',
    width: 120,
    render: (v: string, r: RdaSenzaRdoRow) => (
      <Space size={4}>
        <span style={{ fontWeight: 600, color: '#1677ff' }}>{v ?? '—'}</span>
        {r.cliente_nome && <span style={{ color: '#888', fontSize: 12 }}>· {r.cliente_nome}</span>}
      </Space>
    ),
  },
  {
    title: 'Veicolo',
    key: 'veicolo',
    render: (_: unknown, r: RdaSenzaRdoRow) => {
      const parts = [r.targa, r.marca, r.modello].filter(Boolean)
      return parts.length ? (
        <Space size={4}>
          {r.targa && <Tag color="geekblue" style={{ fontWeight: 600 }}>{r.targa}</Tag>}
          <span>{[r.marca, r.modello].filter(Boolean).join(' ') || ''}</span>
        </Space>
      ) : '—'
    },
  },
  {
    title: 'Intervento',
    dataIndex: 'descrizione_intervento',
    key: 'descrizione_intervento',
    ellipsis: true,
    render: (v: string) => v ?? '—',
  },
]

export function TableRdaSenzaRdoWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<RdaSenzaRdoRow[]>({
    queryKey: ['dashboard', 'manca-rdo-list'],
    queryFn: async () => {
      const res = await axiosInstance.get('/purchase-requests/manca-rdo-list')
      return Array.isArray(res.data) ? res.data : []
    },
    staleTime: 30000,
  })

  return (
    <Card size="small" title="RDA senza RDO">
      <Table
        columns={columns}
        dataSource={data ?? []}
        rowKey={(r) => `${r.work_order_id}-${r.descrizione_intervento}`}
        size="small"
        loading={isLoading}
        pagination={false}
        scroll={{ x: 500 }}
        locale={{ emptyText: 'Nessuna RDA in attesa' }}
        onRow={(r) => ({ onClick: () => navigate('/rda', { state: { expandWorkOrderId: r.work_order_id } }), style: { cursor: 'pointer' } })}
      />
    </Card>
  )
}
